import React from "react";
import ContactForm from "./ContactForm";

const Institucional = ({ toggleModal }) => {
    const apiUrl = process.env.REACT_APP_SITE_URL;

    return (
        <div className="section section-shade section-studio">
            <div
                className="background-image"
                style={{
                    background: `url('${apiUrl}/imagens/person-qrcode.webp') no-repeat center center`
                }}
            ></div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-6 ml-auto mr-auto text-center">
                        <h4 className="intro-title">
                            Obtenha Mais
                        </h4>
                        <p style={{ marginBottom: '2rem', marginTop: '1rem' }}>
                            A plataforma profissional de <strong>Gerenciamento de QR Code</strong> para criar, rastrear e editar todos os seus QR codes em um só lugar.
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="facts">
                            <div className="fact">
                                <i className="fa fa-pencil"></i>
                                <h6>QR Codes Dinâmicos</h6>
                                <p>Edite e altere seus QR codes a qualquer momento.</p>
                            </div>
                            <div className="fact">
                                <i className="fa fa-bar-chart"></i>
                                <h6>Estatísticas de Escaneamento</h6>
                                <p>Rastreie seus QR codes e obtenha insights sobre os escaneamentos.</p>
                            </div>
                            <div className="fact">
                                <i className="fa fa-list"></i>
                                <h6>Criação e Edição em Massa</h6>
                                <p>Crie e edite muitos QR codes em pouco tempo.</p>
                            </div>
                            <div className="fact">
                                <i className="fa fa-folder-o"></i>
                                <h6>Pastas de Campanha</h6>
                                <p>Estruture e organize seus QR codes em pastas de campanha.</p>
                            </div>
                            <div className="fact">
                                <i className="fa fa-paint-brush"></i>
                                <h6>Mais Opções de Design</h6>
                                <p>Crie QR codes transparentes e modelos de design reutilizáveis.</p>
                            </div>
                        </div>
                        <div className="btn-start">
                            <button className="btn btn-lg btn-success" id="start-now-btn" style={{ marginTop: '2rem', marginBottom: '2rem' }} onClick={toggleModal}>
                                Comece Agora
                            </button>
                        </div>
                        {/* Seção de Perguntas Frequentes */}
                        <div className="section" id="faq">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 text-center bottom-spacing">
                                        <h3 className="intro-title">Perguntas Frequentes</h3>
                                    </div>
                                </div>
                                <div className="row faq-content">
                                    <div className="col-md-6">
                                        <h4 className="h6">O que é um QR Code?</h4>
                                        <p className="bottom-spacing">
                                            QR Code significa <strong>Código de Resposta Rápida</strong> e é um tipo de código de barras inventado pela <a href="https://www.denso.com" target="_blank" rel="noreferrer">Denso Wave</a> em 1994. Saiba mais na <a href="https://pt.wikipedia.org/wiki/QR_code" target="_blank" rel="noreferrer">Wikipedia</a>.
                                        </p>

                                        <h4 className="h6">Posso usar os QR Codes gerados para fins comerciais?</h4>
                                        <p className="bottom-spacing">
                                            Sim, todos os QR Codes que você criar com este gerador são gratuitos e podem ser usados para qualquer finalidade.
                                        </p>

                                        <h4 className="h6">Os QR Codes gerados expiram?</h4>
                                        <p className="bottom-spacing">
                                            Não, eles não expiram e funcionarão para sempre! Os QR Codes criados com nosso gerador são estáticos e não param de funcionar após um certo tempo. Você só não pode editar o conteúdo dos QR Codes novamente.
                                        </p>

                                        <h4 className="h6">Meu QR Code não está funcionando, o que posso fazer?</h4>
                                        <p className="bottom-spacing">
                                            Existem muitas razões pelas quais um QR Code pode não funcionar corretamente. Primeiro, verifique os dados inseridos. Às vezes, há pequenos erros de digitação em sua URL que quebram o QR Code. Alguns QR Codes (como vCard) contêm muitos dados. Tente reduzir os dados inseridos no QR Code quando possível. Isso pode facilitar a leitura do código pelos aplicativos de leitura de QR Code. Tente remover o logotipo do QR Code e veja se isso ajuda. Além disso, certifique-se de que há contraste suficiente entre o fundo e o primeiro plano do QR Code. O primeiro plano deve ser sempre mais escuro que o fundo.
                                        </p>
                                    </div>
                                    <div className="col-md-6">
                                        <h4 className="h6">Há um limite de escaneamento para os QR Codes?</h4>
                                        <p className="bottom-spacing">
                                            Não há limite e o QR Code criado funcionará para sempre. Escaneie quantas vezes quiser!
                                        </p>

                                        <h4 className="h6">Vocês salvam meus dados?</h4>
                                        <p className="bottom-spacing">
                                            Não salvamos ou reutilizamos seus dados de nenhuma forma. Armazenamos em cache seus arquivos de imagem de QR Code por 24 horas em nosso servidor para otimizar o desempenho do gerador.
                                        </p>

                                        <h4 className="h6">Por que meu QR Code vCard não está exibindo os campos corretamente?</h4>
                                        <p className="bottom-spacing">
                                            Nem todos os leitores de QR Code seguem o padrão oficial vCard, o que resulta em campos de contato misturados. Tente usar outro aplicativo de leitura de QR Code para obter melhores resultados.
                                        </p>
                                        
                                        <h4 className="h6">O gerador de QR Code funciona em todos os navegadores?</h4>
                                        <p className="bottom-spacing">
                                            Nosso gerador de QR Code precisa de um navegador moderno compatível com HTML5 e é oficialmente compatível com Chrome, Firefox, Safari, Edge e Internet Explorer 11.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ContactForm />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Institucional;